const Shield = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="shield" clipPath="url(#clip0_202_7070)">
        <g id="surface1">
          <path
            id="Vector"
            d="M41.6151 12.2096L41.6137 12.1746C41.5941 11.7424 41.5811 11.2851 41.5732 10.7763C41.5364 8.29508 39.5641 6.24271 37.0825 6.104C31.9087 5.81527 27.9062 4.12819 24.4864 0.794876L24.4572 0.767067C23.3418 -0.255689 21.6591 -0.255689 20.5433 0.767067L20.5142 0.794876C17.0943 4.12819 13.0919 5.81527 7.91802 6.10435C5.43684 6.24271 3.46411 8.29508 3.42737 10.7766C3.41982 11.282 3.40643 11.7393 3.38686 12.1746L3.3848 12.256C3.28421 17.5318 3.15924 24.0978 5.35581 30.0576C6.56362 33.3349 8.39284 36.1838 10.7923 38.5256C13.5252 41.1925 17.1046 43.3098 21.4312 44.8183C21.5719 44.8674 21.7182 44.9073 21.8672 44.9371C22.0773 44.979 22.2888 45 22.5003 45C22.7118 45 22.9236 44.979 23.1334 44.9371C23.2824 44.9073 23.4296 44.8671 23.5711 44.8177C27.8925 43.3064 31.4682 41.1881 34.1986 38.5215C36.5971 36.179 38.4263 33.3294 39.6351 30.0514C41.8399 24.0738 41.7153 17.4954 41.6151 12.2096ZM37.1577 29.1378C34.841 35.4192 30.1117 39.7331 22.6997 42.3251C22.6733 42.3341 22.6452 42.342 22.616 42.3478C22.5394 42.3629 22.4615 42.3629 22.3839 42.3475C22.3551 42.3416 22.3269 42.3341 22.3008 42.3251C14.8809 39.7379 10.1486 35.4264 7.83357 29.1447C5.809 23.6512 5.92367 17.6238 6.02495 12.3065L6.02563 12.2769C6.04623 11.82 6.05997 11.3414 6.06752 10.8154C6.084 9.71369 6.96153 8.80217 8.06531 8.74072C10.9932 8.57729 13.5653 8.0115 15.9288 7.01106C18.2891 6.01199 20.3854 4.60369 22.3369 2.7058C22.4361 2.62203 22.5648 2.62169 22.6637 2.7058C24.6155 4.60369 26.7118 6.01199 29.0718 7.01106C31.4352 8.0115 34.0074 8.57729 36.9356 8.74072C38.0394 8.80217 38.9169 9.71369 38.933 10.8158C38.9409 11.3445 38.9547 11.8231 38.9753 12.2769C39.0762 17.6005 39.1881 23.6326 37.1577 29.1378Z"
            fill="white"
          />
          <path
            id="Vector_2"
            d="M22.4998 11.2861C16.3159 11.2861 11.2852 16.3172 11.2852 22.5008C11.2852 28.6847 16.3159 33.7158 22.4998 33.7158C28.6834 33.7158 33.7144 28.6847 33.7144 22.5008C33.7144 16.3172 28.6834 11.2861 22.4998 11.2861ZM22.4998 31.0749C17.7719 31.0749 13.9257 27.2287 13.9257 22.5008C13.9257 17.7729 17.7719 13.9266 22.4998 13.9266C27.2273 13.9266 31.0736 17.7729 31.0736 22.5008C31.0736 27.2287 27.2273 31.0749 22.4998 31.0749Z"
            fill="white"
          />
          <path
            id="Vector_3"
            d="M25.7227 19.0191L20.5138 24.228L19.1 22.8142C18.5843 22.2985 17.7484 22.2985 17.2327 22.8142C16.7174 23.3299 16.7174 24.1658 17.2327 24.6812L19.5803 27.0288C19.8382 27.2866 20.176 27.4154 20.5138 27.4154C20.8517 27.4154 21.1895 27.2866 21.4473 27.0288L27.59 20.8861C28.1054 20.3704 28.1054 19.5344 27.59 19.0191C27.0744 18.5031 26.2384 18.5031 25.7227 19.0191Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_202_7070">
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Shield
